module.exports = __webpack_public_path__ + "img/logo-um-fl.4a0039ea.png";